export enum RestoreStatus {
  PREPARATION_FAILED = 'preparation_failed',
  PROMOTION_FAILED = 'promotion_failed',
  PREPARING = 'preparing',
  PREPARED = 'prepared',
  PROMOTING = 'promoting',
  PROMOTED = 'promoted',
  DELETING = 'deleting',
  DELETED = 'deleted',
  DELETION_FAILED = 'deletion_failed'
 }